export const enterToTabFunction = (el) => {
  el.addEventListener('keydown', function (event) {
    let goNext = event.key === 'Enter' && !event.shiftKey
    let goBack = event.key === 'Enter' && event.shiftKey
    let inputToGo = null

    if(goNext || goBack) {
      let focusableElements = '.EnterToTab:not([disabled])';
      let inputs = Array.prototype.slice.call(document.querySelectorAll(focusableElements)).filter((el) => isElementDisplayed(el));

      event.preventDefault();

      if (goNext) {
        inputToGo = inputs[inputs.indexOf(event.target) + 1];
      }
      if (goBack) {
        inputToGo = inputs[inputs.indexOf(event.target) - 1];
      }

      if (inputToGo) {
        inputToGo.focus();
      }
    }
  });
}

function isElementDisplayed(element) {
  if (!element) {
    return false;
  }

  const style = getComputedStyle(element);
  
  if (style.display === 'none') {
    return false;
  }

  if (element.parentNode === null || element.tagName === 'BODY') {
    return true;
  }

  return isElementDisplayed(element.parentElement);
}